import { Form, FormField } from "#shared/form";

export class SignInCodeStepForm extends Form<{ code: string }> {
  constructor() {
    super({
      code: new FormField<string>(''),
    }); 

    this.formData.code.addValidator({
      message: 'Неверный код',
      validateFn: (value) => value?.length === 5,
    });
  }

  public override reset() {
    this.formData.code.value = '';
  }
}